export default {
  ON_BOARDING_INTERVIEWS_REPOSITORY: Symbol.for('ON_BOARDING_INTERVIEWS_REPOSITORY'),
  CREATE_ON_BOARDING_INTERVIEW_COMMAND: Symbol.for('CREATE_ON_BOARDING_INTERVIEW_COMMAND'),
};
